<template>
	<div class="index">
		<zmlmenu :num="num"></zmlmenu>
		<swiper ref="mySwiper" :options="swiperOptions" @slideChange="slideChange">
			<swiper-slide>
				<!-- banner -->
				<zmlbanner></zmlbanner>
			</swiper-slide>
			<swiper-slide>
				<!-- 体验下载 -->
				<zmlexperience></zmlexperience>
			</swiper-slide>
			<swiper-slide>
				<!-- 服务 -->
				<zmlservice></zmlservice>
			</swiper-slide>
			<swiper-slide>
				<!-- 优势 -->
				<zmladvantage></zmladvantage>
			</swiper-slide>
			<swiper-slide>
				<!-- 税务筹划 -->
				<zmltaxation :taxation="true"></zmltaxation>
			</swiper-slide>
			<swiper-slide>
				<!-- 一张图片 -->
				<div class="contentBanner flexCenter">
					<img src="../../static/img/bannerImg(2).jpg" alt="">
					<img src="../../static/img/bannerApp3-2.jpg" alt="">
					<!-- <div class="contentBanner-text">
						<p>找船 找货</p>
						<p>就上货运江湖</p>
					</div> -->
				</div>
			</swiper-slide>
			<swiper-slide>
				<!-- 资讯 -->
				<zmlnews></zmlnews>
			</swiper-slide>
			<swiper-slide>
				<zmlfooter></zmlfooter>
			</swiper-slide>
		</swiper>
		<div class="keyTop" @click="goTop" v-if="num >0">
			<span> ↑ </span>
		</div>
	</div>
</template>
<script>
import zmlmenu from '@/components/myMenu.vue'
import zmlfooter from '@/components/myFooter.vue'
import zmlbanner from '@/components/index_banner.vue'
import zmlexperience from '@/components/index_experience.vue'
import zmlservice from '@/components/index_service.vue'
import zmladvantage from '@/components/index_advantage.vue'
import zmltaxation from '@/components/index_taxation.vue'
import zmlnews from '@/components/index_news.vue'
export default{
	name:'home',
	data(){
	  return{
		swiperOptions: {
			slidesPerView : 'auto',
			mousewheel:{
				releaseOnEdges: true,
			},
			direction : 'vertical',
			speed: 800,
			noSwiping: true,
			noSwipingSelector: '.swiper-slide',
			observer:true,
			observeParents:true,
			onTransitionEnd: function(swiper){
				if(swiper.progress==1){
					swiper.activeIndex=swiper.slides.length-1
				}
			}
		},
		num:0,
		newSwiper:null
	  }
	},
	methods:{
		slideChange(){
			// console.log(this.$refs.mySwiper)
			let index = this.$refs.mySwiper.swiper.realIndex;
			// console.log(this.$refs.mySwiper.swiper.realIndex);
			if(index > 0){
				this.num = index;
			}else{
				this.num = 0;
			}
		},
		goTop(swiper) {
			let that = this
			that.swiper.slideTo(0, 1000, false)
		}
	},
	mounted(){
		if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
		   this.$refs.mySwiper.swiper.params.noSwiping = false
		}else{
		   this.$refs.mySwiper.swiper.params.noSwiping = true
		}
	},
	components:{
		zmlmenu,
		zmlfooter,
		zmlbanner,
		zmlexperience,
		zmlservice,
		zmladvantage,
		zmltaxation,
		zmlnews,
	},
	computed:{
		swiper(){
		  return this.$refs.mySwiper.swiper;
		}
	}
}
</script>
<style scoped="scoped">
.index{
	width: 100%;
	height: 100%;
}
.swiper-container{
	width: 100%;
	height: 100%;
}
.swiper-wrapper{
	width: 100%;
	height: 100%;
}
.swiper-slide{
	width: 100%;
	height: 100%;
	overflow: hidden;
}
.swiper-slide:nth-last-of-type(1){
	height: auto !important;
}
/* 一张图片 */
.contentBanner{
	width: 100%;
	height: 100%;
	overflow: hidden;
	position: relative;
}
.contentBanner img{
	width: 100%;
	/* height: 100%; */
}
.contentBanner-text{
	position: absolute;
	top: 50%;
	right: 22%;
	transform: translateY(-50%);
	text-align: right;
	font-size: 74px;
	color: #fff;
}
.contentBanner-text p:nth-of-type(1){
	margin-bottom: 20px;
}
.contentBanner img:nth-of-type(2){
	display: none;
}

@media only screen and (max-width: 750px){
	.contentBanner img:nth-of-type(1){
		display: none;
	}
	.contentBanner img:nth-of-type(2){
		display: block;
		height: 100%;
	}
	.contentBanner-text{
		font-size:37px;
		right: 10%;
	}
	.contentBanner{
		justify-content: flex-start;
	}
}
.keyTop{
	position: fixed;
	z-index: 5;
	display: inline-block;
	height: 50px;
	width: 50px;
	bottom: 30px;
	right: 20px;
	background-color: #197ffd;
	border-radius: 50%;
	text-align: center;
	line-height: 50px;
	color: #fff;
}
.index >>> .footer-2 .el-dialog__wrapper{
	height: 100vh;
	top: 690vh;
}
</style>



// WEBPACK FOOTER //
// src/pages/home.vue